import classNames from 'classnames';
import PropTypes from 'prop-types';

export const PAGE_GUTTER =
  'px-4 sm:px-6 lg:px-8 xl:px-16';
export const PAGE_WIDTH =
  'mx-auto w-full max-w-[1440px]';

const PageContent = ({
  children,
  className,
  as: Component = 'div'
}) => (
  <Component
    className={classNames(
      PAGE_WIDTH,
      PAGE_GUTTER,
      className
    )}
  >
    {children}
  </Component>
);

PageContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  as: PropTypes.elementType
};

PageContent.defaultProps = {
  children: null,
  className: '',
  as: 'div'
};

export default PageContent;
